import { Component, HostListener, OnInit } from '@angular/core';
import { SubscriberService } from 'src/app/services/subscriberService/subscriber.service';
import { SwitchDialogService } from 'src/app/services/switchDialogService/switch-dialog-service';
import { UserService } from 'src/app/services/userService/user.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.less']
})
export class NavbarComponent implements OnInit {
  features = environment.features;
  user;
  pageYoffset;
  constructor(private subscriberService: SubscriberService, private userService: UserService, private switchDialogService: SwitchDialogService) { }

  /** Initialize component  */
  ngOnInit() {
    this.user = this.userService.getUser();

    this.userService.getLoggedInStatus.subscribe(resp => {
      this.user = this.userService.getUser();
    });
  }

  /** Open Switch Profile Dialog */
  switchProfile() {
    this.switchDialogService.openSwitchProfileDialog(this.userService);
  }

  /** Logout from the service */
  logOut() {
    this.subscriberService.logOut(this.userService).then(resp => { });
  }

  /** Scroll listener used for afix effe in the nav bar  */
  @HostListener('window:scroll', ['$event']) onScroll() {
    this.pageYoffset = window.pageYOffset;
  }
}